module.exports = __webpack_public_path__ + "img/Group5.b9931827.png";